// Session de l'interface : le jeton reçu à la connexion accompagne chaque
// appel à l'API. S'il est absent, expiré ou refusé : retour à la connexion.

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const CLES_SESSION = ["fruitycall_auth", "fruitycall_token", "fruitycall_user"];

export const jetonSession = () => localStorage.getItem("fruitycall_token");

// Le jeton porte sa date d'expiration (champ exp, en secondes)
export function sessionValide() {
  const jeton = jetonSession();
  if (!jeton) return false;
  try {
    const charge = jeton.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(charge));
    return !exp || exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function fermerSession() {
  CLES_SESSION.forEach((cle) => localStorage.removeItem(cle));
}

const estAppelApi = (url) =>
  url.startsWith(`${API_URL}/api/`) || url.startsWith("/api/");

// Ajoute le jeton à tous les appels de l'API, sans modifier chaque page
export function installerSessionApi() {
  const fetchNatif = window.fetch.bind(window);
  window.fetch = async (ressource, options = {}) => {
    const url = typeof ressource === "string" ? ressource : ressource.url;
    if (!estAppelApi(url) || url.includes("/api/auth/login")) {
      return fetchNatif(ressource, options);
    }
    const headers = new Headers(
      options.headers || (typeof ressource === "string" ? undefined : ressource.headers)
    );
    const jeton = jetonSession();
    if (jeton) headers.set("Authorization", `Bearer ${jeton}`);

    const reponse = await fetchNatif(ressource, { ...options, headers });
    if (reponse.status === 401) {
      fermerSession();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.assign("/login");
      }
    }
    return reponse;
  };
}
